import { Box } from '@mui/material';

import TreatmentPlanItem from './TreatmentPlanItem';
import SupervisionItem from './SupervisionItem';
import { ActionRequiredItemEnum } from '../../../constants';

import type {
  IBtSupervision,
  IClientAssessment,
  IClientSupervision,
  IGroupSupervision,
  IParentSupervision,
  ITreatmentPlan,
  IActionRequiredItem,
} from '../../../utils/types';

interface ActionRequiredItemProps {
  actionRequiredItem: IActionRequiredItem;
  sx?: any;
}

type TreatmentPlanActionRequiredItem = IActionRequiredItem & {
  type: ActionRequiredItemEnum.TreatmentPlan;
  item: ITreatmentPlan;
};

type SupervisionActionRequiredItem = IActionRequiredItem & {
  type: Exclude<ActionRequiredItemEnum, ActionRequiredItemEnum.TreatmentPlan>;
  item:
    | IBtSupervision
    | IClientSupervision
    | IGroupSupervision
    | IParentSupervision
    | IClientAssessment;
};

function isTreatmentPlanActionRequiredItem(
  actionRequiredItem: IActionRequiredItem,
): actionRequiredItem is TreatmentPlanActionRequiredItem {
  return actionRequiredItem.type === ActionRequiredItemEnum.TreatmentPlan;
}

function isSupervisionActionRequiredItem(
  actionRequiredItem: IActionRequiredItem,
): actionRequiredItem is SupervisionActionRequiredItem {
  return actionRequiredItem.type !== ActionRequiredItemEnum.TreatmentPlan;
}

function ActionRequiredItem(props: ActionRequiredItemProps) {
  const { actionRequiredItem, sx } = props;

  if (isTreatmentPlanActionRequiredItem(actionRequiredItem)) {
    return (
      <Box sx={sx}>
        <TreatmentPlanItem treatmentPlan={actionRequiredItem.item} isActionRequiredItem={true} />
      </Box>
    );
  }

  if (isSupervisionActionRequiredItem(actionRequiredItem)) {
    return (
      <Box sx={sx}>
        <SupervisionItem
          supervision={actionRequiredItem.item}
          type={actionRequiredItem.type}
          isActionRequiredItem={true}
        />
      </Box>
    );
  }

  return null;
}

export default ActionRequiredItem;
